<!-- One prev/next pair drives every panel: the chevrons sit on the outside edges and the month headings
     ride above their own grids, so a two-up view reads as one continuous run of months. `Today` sits
     inside the right edge, before the next chevron, so it never displaces a month heading. -->
<div class="calendar-header">
  <button class="calendar-nav" type="button" aria-label="Previous month" (click)="onShiftMonth(-1)">
    <i class="fa-solid fa-chevron-left"></i>
  </button>
  @for (panel of $panels(); track panel.label) {
    <span class="calendar-title">{{ panel.label }}</span>
  }
  <!-- Withheld rather than disabled once today is on screen: the header keeps its width either way
       because the slot is only ever occupied when the jump has somewhere to go. -->
  @if ($todayAvailable()) {
    <wb-button-link buttonClass="calendar-today" label="Today" [size]="linkSize" tooltip="Go to today" (onClick)="onToday()" />
  }
  <button class="calendar-nav" type="button" aria-label="Next month" (click)="onShiftMonth(1)">
    <i class="fa-solid fa-chevron-right"></i>
  </button>
</div>

<div class="calendar-panels">
  @for (panel of $panels(); track panel.label) {
    <div class="calendar-panel">
      <div class="calendar-weekdays">
        @for (weekday of weekdays; track weekday) {
          <span class="calendar-weekday">{{ weekday }}</span>
        }
      </div>

      <div class="calendar-grid" role="grid" [attr.aria-label]="panel.label">
        @for (cell of panel.cells; track $index) {
          @if (cell.date) {
            <button class="calendar-day" type="button" role="gridcell" [class.selected]="isSelected(cell.date)" [class.in-range]="isInRange(cell.date)" [class.preview-range]="isPreviewRange(cell.date)" [class.preview-end]="isPreviewEnd(cell.date)" [class.today]="isToday(cell.date)" [attr.aria-selected]="isSelected(cell.date)" [attr.data-date]="cell.date" [attr.tabindex]="isTabStop(cell.date) ? 0 : -1" [attr.data-autofocus-control]="isTabStop(cell.date) ? 'true' : null" [disabled]="isDisabled(cell.date)" (click)="onSelect(cell)" (keydown)="onKeydown($event, cell.date)" (focus)="onDayFocus(cell.date)" (blur)="onDayBlur()" (mouseenter)="onHover(cell.date)" (mouseleave)="onHover(null)">{{ cell.day }}</button>
          } @else {
            <span class="calendar-blank"></span>
          }
        }
      </div>
    </div>
  }
</div>
